export const PALETTES = {
  sunset: { primary: "#F0326E", accent: "#FFC23D", bg: "#FFF7F2", ink: "#1B1033", label: "Sunset" },
  ocean: { primary: "#0E7490", accent: "#22D3EE", bg: "#F0FBFF", ink: "#0B2530", label: "Ocean" },
  forest: { primary: "#15803D", accent: "#A3E635", bg: "#F4FBF2", ink: "#0F2A17", label: "Forest" },
  royal: { primary: "#1E3A8A", accent: "#F59E0B", bg: "#F7F8FC", ink: "#0F172A", label: "Royal" },
  earth: { primary: "#9A3412", accent: "#F4C27A", bg: "#FBF5EE", ink: "#2B1B0E", label: "Earth" },
  mono: { primary: "#111111", accent: "#F0326E", bg: "#FFFFFF", ink: "#111111", label: "Mono" },
};

export const FONTS = {
  modern: { heading: "Outfit, sans-serif", label: "Modern" },
  elegant: { heading: "'Playfair Display', serif", label: "Elegant" },
  bold: { heading: "'Archivo Black', sans-serif", label: "Bold" },
};

export const PHOTO_THEMES = ["bakery", "restaurant", "beauty", "fashion", "construction", "farming", "business", "fitness",
  "health", "education", "travel", "automotive", "events", "city"];
